(function () {
    "use strict";

    angular
        .module("app")
        .directive("membraneSearchHelp", ["SearchFactory", membraneSearchHelp]);

    function membraneSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.membraneId = "";
                        scope.membraneDesc = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.membraneDesc === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.membraneSearch(function (membrane) {
                        scope.membraneId = membrane ? membrane.MembraneId : "";
                        scope.membraneDesc = membrane ? membrane.MembraneDesc : "";
                        scope.displayValue = scope.membraneDesc;

                        if (scope.prevDisplayValue !== scope.displayValue) {

                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.$watch("membraneDesc", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.membraneDesc;
                scope.prevDisplayValue = scope.displayValue;

            },
            scope: { membraneId: "=", membraneDesc: "=", readOnly: "=", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

